import { isAbortError } from '@app/errors/AbortError'

import { reloadForChunkError, shouldReloadForChunkError } from './chunkLoadErrorReload'
import { captureException } from './errorReport'

/**
 * The error argument to pass `spawn` when a failing body matters. Without one `spawn` swallows the
 * error outright — no throw, so `installChunkLoadErrorReload`'s `unhandledrejection` listener never
 * sees it either, and a chunk that will not load after a deploy silently kills the feature instead
 * of triggering the reload that fixes it.
 */
export const reportSpawnFailure = (service: string) => (e: unknown) => {
  switch (spawnFailureAction(e)) {
    case 'ignore':
      return
    case 'reload':
      return reloadForChunkError()
    case 'report':
      return captureException(e, { tags: { service } })
  }
}

/** Split from the effect so the policy is testable without mocking Sentry or `location.reload`. */
export const spawnFailureAction = (e: unknown): 'ignore' | 'reload' | 'report' => {
  // Teardown aborts whatever the body was waiting on; that is the stack doing its job.
  if (isAbortError(e)) return 'ignore'
  if (shouldReloadForChunkError(e)) return 'reload'
  return 'report'
}
